import { render, staticRenderFns } from "./AdminSurveyRecords.vue?vue&type=template&id=20ab7fbc&scoped=true&"
import script from "./AdminSurveyRecords.vue?vue&type=script&lang=js&"
export * from "./AdminSurveyRecords.vue?vue&type=script&lang=js&"
import style0 from "./AdminSurveyRecords.vue?vue&type=style&index=0&id=20ab7fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab7fbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VSpacer,VTextarea,VToolbar,VToolbarTitle})
